import React from "react";
import PopupWrapper from "../../common/PopupWrapper";
import ClickToCopyButton from "components/common/ClickToCopyButton";
import EditableJsonEditor from "components/common/EditableJsonEditor";
import { checkIsValidJson, stringifyJson } from "helpers/JsonCheck";

class PreviewInJsonPopover extends React.PureComponent {
  render() {
    const {
      triggerElement,
      data,
      json,
      place = "bottom",
      popoverWidth = "600px",
    } = this.props;

    let style = {
      // width: popoverWidth,
      maxHeight: "460px",
      // overflowY: "auto",
    };
    if (popoverWidth) {
      style.width = popoverWidth;
    }

    const parsedData = data || checkIsValidJson(json) || {};
    const parsedJson = json || stringifyJson(data) || "";

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        // hideArrow={false}
        triggerElement={triggerElement}
        popupElement={
          <div className="shadow border flex flex-col p-4" style={style}>
            <EditableJsonEditor
              customClass="min-h-0 flex-1"
              originalConfig={parsedData}
              readOnly={true}
            />

            <div className="flex justify-end">
              <ClickToCopyButton copyText={parsedJson}></ClickToCopyButton>
            </div>
          </div>
        }
      ></PopupWrapper>
    );
  }
}

export default PreviewInJsonPopover;
